import API from "../api/manager";
import config from "../api/config";

const login = (data) => {
  return API(
    {
      method: "POST",
      url: config.urls.auth.login,
      data,
    },
    false,
  );
};

const profile = () => {
  return API({
    method: "GET",
    url: config.urls.auth.profile,
  });
};

const changePassword = (data) => {
  return API({
    method: "PUT",
    url: config.urls.auth.change_password,
    data,
  });
};

const createPublicLink = (data) => {
  return API({
    method: "POST",
    url: config.urls.auth.create_public_link,
    data,
  });
};

const removeToken = (data) => {
  return API({
    method: "DELETE",
    url: config.urls.auth.remove_token,
    data,
  });
};

const createEsign = (data) => {
  return API({
    method: "POST",
    url: config.urls.createEsignIn,
    data,
  });
};

export default {
  login,
  profile,
  changePassword,
  createPublicLink,
  removeToken,
  createEsign
};
